module.exports = __webpack_public_path__ + "static/img/landing_background.6383b08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/landing_background.jpg
// module id = uO5h
// module chunks = 0